import { Outlet, createFileRoute } from "@tanstack/react-router";

import { FinanceShell } from "@/features/finance/modules/finance-shell/finance-shell";
import { m } from "@/paraglide/messages.js";

/** Every finance page is a tab under this one, which also gives the breadcrumb its "Finances" step. */
export const Route = createFileRoute("/(private)/finances")({
  loader: () => ({ crumb: m.finance_nav_label() }),
  component: FinancesLayout,
});

function FinancesLayout() {
  return (
    <FinanceShell>
      <Outlet />
    </FinanceShell>
  );
}
